// extracted by mini-css-extract-plugin
export default {"screen":"RduXq1TR","header":"WzubArwE","eyebrow":"PFGKJ1EA","title":"S1QP39IN","list":"QbvFu29s","skeleton":"mZDhuBBj","empty":"I8thsaMr"};